import type { FC, SVGProps } from 'react'

export const Record: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12.5" cy="12.2748" r="5" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 5.27478C8.63401 5.27478 5.5 8.40879 5.5 12.2748C5.5 16.1408 8.63401 19.2748 12.5 19.2748C16.366 19.2748 19.5 16.1408 19.5 12.2748C19.5 8.40879 16.366 5.27478 12.5 5.27478ZM3.5 12.2748C3.5 7.30422 7.52944 3.27478 12.5 3.27478C17.4706 3.27478 21.5 7.30422 21.5 12.2748C21.5 17.2453 17.4706 21.2748 12.5 21.2748C7.52944 21.2748 3.5 17.2453 3.5 12.2748Z"
      fill="currentColor"
    />
  </svg>
)
